import { useCallback } from 'react';
import api from '@/services/ApiService';
import useDataStore from '@/store/data';
import { toast } from 'react-toastify';
import ToastMessage from '@/components/toasts/ToastMessage';

/**
 * Hook for loading a single item by its ID
 * @param {string} schemaName - Name of the schema
 * @param {Function} onError - Optional callback function called when loading fails
 * @returns {Function} loadItem - Function to load a single item
 */
export default function useSingleItemLoader(schemaName, onError = null) {
  const { upsert, schemas } = useDataStore();
  const schema = schemas[schemaName];

  const loadItem = useCallback(
    async (itemId) => {
      if (!itemId || !schema) {
        return null;
      }

      try {
        const { data: responseData } = await api.get(`${schemaName}/${itemId}`);

        if (responseData) {
          upsert(responseData);
          return responseData;
        }

        return null;
      } catch (error) {
        if (onError) {
          onError(error, itemId);
        }
        toast.error(
          <ToastMessage
            title="Fehler beim Laden des Items"
            subtitle={error?.message}
          />,
        );
        return null;
      }
    },
    [schemaName, schema, upsert, onError],
  );

  return loadItem;
}
